import RepresenterEntity from "../RepresenterEntity";

export default class BrokerEntity extends RepresenterEntity {
    constructor() {
        super();
    }
}
